// Vuex transaction module mutations
import { FILL_LIST, FILL_AGENTS, SET_CALLING_AGENT_DETAILS } from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.agentsBelongsToUserlist.records = payload.records;
    _state.agentsBelongsToUserlist.total = payload.total;
  },
  [FILL_AGENTS](state, payload) {
    const _state = state;
    _state.agentsList.records = payload.records;
    _state.agentsList.total = payload.total;
  },
  [SET_CALLING_AGENT_DETAILS](state, payload) {
    const _state = state;
    _state.callingAgentDetails.details = payload;
  },
};
